(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-section-type="product-template"]').forEach(function (section) {
      if (section.agpDepositCleanup) return;
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-agp-deposit]'));
      var enquiries = Array.prototype.slice.call(section.querySelectorAll('[data-agp-backorder-help]'));
      var stockLabels = Array.prototype.slice.call(section.querySelectorAll('[data-agp-stock-status]'));
      if (!panels.length && !enquiries.length && !stockLabels.length) return;
      var nativeForm = section.querySelector('[data-product-form]');
      var select = nativeForm && nativeForm.querySelector('select[name="id"]');
      if (!select) return;
      function money(cents, panel) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: panel.dataset.currency
        }).format(cents / 100);
      }
      function totals(event) {
        var panel = event.target.closest('[data-agp-deposit]');
        if (!panel) return;
        var input = panel.querySelector('[name="quantity"]');
        if (!input.checkValidity()) return;
        var quantity = Number(input.value);
        panel.querySelector('[data-deposit-total]').textContent = money(Number(panel.dataset.depositCents) * quantity, panel);
        panel.querySelector('[data-deposit-balance]').textContent = money(Number(panel.dataset.balanceCents) * quantity, panel);
        panel.querySelector('[data-deposit-button-total]').textContent = money(Number(panel.dataset.depositCents) * quantity, panel);
        panel.querySelector('[data-deposit-quantity-label]').textContent = '(' + quantity + (quantity === 1 ? ' wheel)' : ' wheels)');
      }
      function show(id) {
        var active = null;
        stockLabels.forEach(function (label) {
          label.hidden = label.dataset.wheelVariant !== String(id || '');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.wheelVariant !== String(id || '');
          if (!panel.hidden) active = panel;
          else panel.querySelector('[type="checkbox"]').checked = false;
        });
        enquiries.forEach(function (panel) {
          panel.hidden = panel.dataset.wheelVariant !== String(id || '');
          if (!panel.hidden) active = panel;
        });
        section.classList.toggle('agp-has-deposit', !!active);
        section.dispatchEvent(new CustomEvent('agp:deposit-change', {bubbles: true}));
      }
      function variantChanged(event) { show(event.variant && event.variant.id); }
      function masterChanged() { show(select.value); }
      function submit(event) {
        var form = event.target.closest('[data-agp-deposit-form]');
        if (!form) return;
        var panel = form.closest('[data-agp-deposit]');
        if (panel.hidden || panel.dataset.wheelVariant !== select.value || form.dataset.submitting === 'true') {
          event.preventDefault(); return;
        }
        if (!form.reportValidity()) { event.preventDefault(); return; }
        // Normal Shopify form submission: the server uses the real deposit SKU's
        // price. Never substitute the wheel ID or supply a price from JavaScript.
        form.dataset.submitting = 'true';
        form.querySelector('[type="submit"]').setAttribute('aria-busy', 'true');
      }
      function reset() {
        panels.forEach(function (panel) {
          var form = panel.querySelector('form');
          delete form.dataset.submitting;
          form.querySelector('[type="submit"]').removeAttribute('aria-busy');
        });
      }
      section.addEventListener('input', totals);
      section.addEventListener('submit', submit);
      select.addEventListener('change', masterChanged);
      window.addEventListener('pageshow', reset);
      if (window.jQuery) window.jQuery(section).on('variantChange.agpDeposits', variantChanged);
      show(select.value);
      section.agpDepositCleanup = function () {
        section.removeEventListener('input', totals);
        section.removeEventListener('submit', submit);
        select.removeEventListener('change', masterChanged);
        window.removeEventListener('pageshow', reset);
        if (window.jQuery) window.jQuery(section).off('variantChange.agpDeposits', variantChanged);
        delete section.agpDepositCleanup;
      };
    });
  }
  function ready() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-section-type="product-template"]').forEach(function (section) {
      if (section.agpDepositCleanup) section.agpDepositCleanup();
    });
  });
}());
